const en = {
  title: 'Edit with agent',
  close: 'Close agent',
  intro: 'Describe a design or lineup change. Review the proposal, then apply it to this draft.',
  draftHint: 'Applied changes appear in the editor immediately. Save when ready; publish separately.',
  message: 'Message',
  placeholder: 'For example: make the background dark blue, or move Saturday’s shows 30 minutes later.',
  send: 'Send',
  busy: 'Preparing changes…',
  you: 'You',
  assistant: 'Agent',
  proposed: 'Proposed changes',
  apply: 'Apply changes',
  undo: 'Undo agent changes',
  applied: 'Changes applied to the draft.',
  undone: 'Agent changes undone.',
  requestFailed: 'The agent could not respond. Please try again.',
  invalidReply: 'The agent returned changes that could not be safely applied. Please try again.',
  stale: 'Some affected data changed. Ask the agent again before applying.',
  undoStale: 'The affected fields changed after applying. Undo them in the editor instead.',
  timeout: 'The agent took too long to respond. Please try again.',
  requestErrors: {
    unavailable: 'The agent is currently unavailable. Please contact your administrator.',
    limit: 'The agent usage limit has been reached. Please try again later.',
    invalid: 'This request could not be processed. Try a shorter message or fewer changes.',
    session: 'Your session expired. Please sign in again.',
    permission: 'Your account does not have permission to use the agent.',
    draft: 'This version changed or is no longer a draft. Reopen it before using the agent.',
    failed: 'The agent could not respond. Please try again.',
  },
  added: 'Add',
  removed: 'Remove',
  nothing: 'Empty',
  yes: 'Yes',
  no: 'No',
  sections: { infos: 'Info & Layout', stylesheet: 'Design', artists: 'Artists', shows: 'Shows' },
  fields: {
    festival_name: 'Festival name', lineup_release_date: 'Lineup release', show_reminder_minutes: 'Reminder (minutes)',
    homepage: 'Homepage', enabled: 'Enabled', start_date: 'Start', end_date: 'End', before_message: 'Before the festival', after_message: 'After the festival',
    tickets: 'Tickets', description: 'Description', link: 'Link', background: 'Background', type: 'Type',
    primary_color: 'Primary color', secondary_color: 'Secondary color', image_opacity: 'Image opacity',
    title_color: 'Title color', caption_color: 'Caption color', body_color: 'Body color', nav_bar_logo_height: 'Navigation logo height', festival_name_color: 'Festival name color',
    show: 'Shows', cell_height: 'Item height', details_header_height: 'Detail header height', items_artist_name_color: 'Artist name color', items_scene_name_color: 'Stage name color',
    items_show_date_color: 'Show date color', buttons_tint_color: 'Button color', items_layout: 'Item layout', items_tag_background_color: 'Tag background color', items_tag_text_color: 'Tag text color',
    news: 'News', padding: 'Padding', header_height: 'Header height', items_spacing: 'Item spacing', items_background_color: 'Item background color', items_title_color: 'Item title color',
    items_subtitle_color: 'Item subtitle color', items_date_color: 'Item date color', pages: 'Pages', icon_height: 'Icon height', row_height: 'Row height', section_color: 'Section color',
    section_height: 'Section height', icon_tint_color: 'Icon color', notifications: 'Notifications', items_vertical_spacing: 'Vertical spacing', tab_bar: 'Tab bar', selected_color: 'Selected color',
    background_color: 'Background color', background_opacity: 'Background opacity', empty_show_list: 'Empty lineup', buy_ticket_button_text_color: 'Ticket button text color', buy_ticket_button_background_color: 'Ticket button background color',
    name: 'Name', style: 'Style', music_preview: 'Music links', spotify_url: 'Spotify', apple_music_url: 'Apple Music', youtube_url: 'YouTube', soundcloud_url: 'SoundCloud', other_url: 'Other link',
    scene_id: 'Stage', artist_id: 'Artist', featured: 'Featured',
  },
};

const fr: typeof en = {
  title: 'Modifier avec l’agent',
  close: 'Fermer l’agent',
  intro: 'Décrivez une modification du design ou de la programmation. Vérifiez la proposition, puis appliquez-la au brouillon.',
  draftHint: 'Les modifications apparaissent immédiatement dans l’éditeur. Enregistrez quand vous le souhaitez\u00a0; la publication reste séparée.',
  message: 'Message',
  placeholder: 'Par exemple\u00a0: un fond bleu foncé, ou décaler les shows du samedi de 30 minutes.',
  send: 'Envoyer',
  busy: 'Préparation des modifications…',
  you: 'Vous',
  assistant: 'Assistant',
  proposed: 'Modifications proposées',
  apply: 'Appliquer les modifications',
  undo: 'Annuler les modifications de l’agent',
  applied: 'Modifications appliquées au brouillon.',
  undone: 'Modifications de l’agent annulées.',
  requestFailed: 'L’agent n’a pas pu répondre. Réessayez.',
  invalidReply: 'L’agent a proposé des modifications qui ne peuvent pas être appliquées en toute sécurité. Réessayez.',
  stale: 'Certaines données concernées ont changé. Relancez l’agent avant d’appliquer les modifications.',
  undoStale: 'Les champs concernés ont été modifiés depuis. Annulez les modifications dans l’éditeur.',
  timeout: 'L’agent a mis trop de temps à répondre. Réessayez.',
  requestErrors: {
    unavailable: 'L’agent est indisponible pour le moment. Contactez votre administrateur.',
    limit: 'La limite d’utilisation de l’agent est atteinte. Réessayez plus tard.',
    invalid: 'Cette demande n’a pas pu être traitée. Essayez un message plus court ou moins de modifications.',
    session: 'Votre session a expiré. Reconnectez-vous.',
    permission: 'Votre compte n’a pas l’autorisation d’utiliser l’agent.',
    draft: 'Cette version a changé ou n’est plus un brouillon. Rouvrez-la avant d’utiliser l’agent.',
    failed: 'L’agent n’a pas pu répondre. Réessayez.',
  },
  added: 'Ajouter',
  removed: 'Supprimer',
  nothing: 'Vide',
  yes: 'Oui',
  no: 'Non',
  sections: { infos: 'Infos & mise en page', stylesheet: 'Apparence', artists: 'Artistes', shows: 'Shows' },
  fields: {
    festival_name: 'Nom du festival', lineup_release_date: 'Annonce de la programmation', show_reminder_minutes: 'Rappel (minutes)',
    homepage: 'Accueil', enabled: 'Activé', start_date: 'Début', end_date: 'Fin', before_message: 'Avant le festival', after_message: 'Après le festival',
    tickets: 'Billetterie', description: 'Description', link: 'Lien', background: 'Arrière-plan', type: 'Type',
    primary_color: 'Couleur principale', secondary_color: 'Couleur secondaire', image_opacity: 'Opacité de l’image',
    title_color: 'Couleur des titres', caption_color: 'Couleur des légendes', body_color: 'Couleur du texte', nav_bar_logo_height: 'Hauteur du logo de navigation', festival_name_color: 'Couleur du nom du festival',
    show: 'Shows', cell_height: 'Hauteur des éléments', details_header_height: 'Hauteur de l’en-tête du détail', items_artist_name_color: 'Couleur du nom des artistes', items_scene_name_color: 'Couleur du nom des scènes',
    items_show_date_color: 'Couleur des dates', buttons_tint_color: 'Couleur des boutons', items_layout: 'Disposition des éléments', items_tag_background_color: 'Fond des badges', items_tag_text_color: 'Texte des badges',
    news: 'Actus', padding: 'Marge intérieure', header_height: 'Hauteur de l’en-tête', items_spacing: 'Espacement des éléments', items_background_color: 'Fond des éléments', items_title_color: 'Titres des éléments',
    items_subtitle_color: 'Sous-titres des éléments', items_date_color: 'Couleur des dates', pages: 'Pages', icon_height: 'Hauteur des icônes', row_height: 'Hauteur des lignes', section_color: 'Couleur des sections',
    section_height: 'Hauteur des sections', icon_tint_color: 'Couleur des icônes', notifications: 'Notifications', items_vertical_spacing: 'Espacement vertical', tab_bar: 'Barre d’onglets', selected_color: 'Couleur de sélection',
    background_color: 'Couleur du fond', background_opacity: 'Opacité du fond', empty_show_list: 'Programmation vide', buy_ticket_button_text_color: 'Texte du bouton billetterie', buy_ticket_button_background_color: 'Fond du bouton billetterie',
    name: 'Nom', style: 'Style', music_preview: 'Liens musicaux', spotify_url: 'Spotify', apple_music_url: 'Apple Music', youtube_url: 'YouTube', soundcloud_url: 'SoundCloud', other_url: 'Autre lien',
    scene_id: 'Scène', artist_id: 'Artiste', featured: 'À la une',
  },
};

const messages = { en, fr };
export default messages;
